import React, {
    useContext,
    useEffect,
} from "react"

import {
    useLocation,
} from "react-router-dom"

import {
    EMETLAssessmentTaskWithDetails,
} from "../Model/EMETLAssessment.m"

import {
    Context, 
    EMETLContext,
} from "../Model/Contexts/AppContext"

import AssessmentTasksVM from "../ViewModel/AssessmentTasks.vm"
import EMETLAssessmentTask from "./Components/EMETLAssessmentTask"

export type AssessmentTaskProps = {
    assessmentTasks?: EMETLAssessmentTaskWithDetails[],
    assessmentID?: number,
    autoSave?: (ID: number, rating: number, needs: string) => Promise<boolean>,
    noTasksMessage?: string,
}

const AssessmentTasks = (props?: AssessmentTaskProps) => {
    const {
        assessmentID: assessmentIDProps,
        assessmentTasks,
        autoSave = null,
        noTasksMessage = "No tasks have been saved to this assessment."
    } = props

    AssessmentTasksVM.ctx = useContext(Context)
    const {
        amplify,
    } = AssessmentTasksVM.ctx as EMETLContext

    const location = useLocation()
    
    const {
        assessmentID: assessmentIDRouter,
    } = location.state || {} 

    const assessmentID = assessmentIDProps || assessmentIDRouter

    const load = async () => {
        // if (assessmentID) {
        //     const resp = await AssessmentTasksVM.getAssessmentTasks(assessmentID)
        //     console.log(resp)
            
        // }
    }

    useEffect(() => {
        AssessmentTasksVM.db = amplify
        if (assessmentID) {
            load()
            
        }
    }, [assessmentIDProps, assessmentIDRouter, amplify])

    return (
        !!assessmentTasks?.length && assessmentTasks?.map(
            (taskForAssessment: EMETLAssessmentTaskWithDetails) => (
                <EMETLAssessmentTask
                    key={taskForAssessment.ID} 
                    assessmentTask={taskForAssessment} 
                    autoSave={autoSave}
                />
            )
        ) || <h4 className="text-secondary">{noTasksMessage}</h4>
    )
}

export default AssessmentTasks